
import { Component, ElementRef, EventEmitter, Input, Output, ViewChild, OnChanges, forwardRef, SimpleChanges } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import { CdkVirtualScrollViewport } from '@angular/cdk/scrolling';

import { BaseFormWidgetComponent } from '../../../shared/base-form.component';

declare global {
    interface HTMLElement {
        scroll_viewport: CdkVirtualScrollViewport;
    }
}

@Component({
    selector: 'dropdown',
    template: `<div [class]="'dropdown' + (klass ? ' ' + klass : '') + (disabled ? ' disable' : '') + (show ? ' show' : '')" widget
    #body (window:resize)="resize()">
    <div #ref class="reference"></div>
    <div class="tooltip" [class.bottom]="bottom" tooltip name="dropdown-list" [template]="tooltip" [position]="bottom ? 'top' : 'bottom'"
        offset="middle" [triangle]="false" [(show)]="show" [autoclose]="false" (event)="select($event)">
    </div>
    <div #active class="item active" (touchrelease)="showList()">
        <div class="text" [class.placeholder]="model < 0 || !list_items || list_items.length <=model || !list_items[model]">
            {{ model < 0 || !list_items || list_items.length <=model || !list_items[model] ? placeholder :
                list_items[model].name || list_items[model] }}
        </div>
        <div class="icon">
            <div class="down"></div>
        </div>
    </div>
    <div class="list">
        <div class="item" *ngIf="longest">
            <div class="text">{{ longest.name || longest }}</div>
            <div class="icon"></div>
        </div>
    </div>
    <ng-template #tooltip>
        <div [class]="'dropdown-list' + (klass ? ' ' + klass : '')" [style.font-size]="font_size + 'px'" [style.width]="width + 'px'">
            <div class="item active" *ngIf="!bottom" (touchrelease)="showList()">
                <div class="text" [class.placeholder]="model < 0 || !list_items || list_items.length <=model || !list_items[model]">
                    {{ model < 0 || !list_items || list_items.length <=model || !list_items[model] ? placeholder :
                        list_items[model].name || list_items[model] }} </div> <div class="icon">
                        <div class="up"></div>
                </div>
            </div>
            <div class="search" *ngIf="filter&&!bottom" (touchrelease)="focus()">
                <div class="icon">
                    <div class="search-icon"></div>
                </div>
                <div class="input"><input #input [(ngModel)]="search" (ngModelChange)="filterItems()" placeholder="Filter"></div>
            </div>
            <div class="list show" [style.height]="(list_height * 2 * font_size) + 'px'">
                <ng-container *ngIf="filtered_list">
                    <cdk-virtual-scroll-viewport #viewport [itemSize]="2 * font_size">
                        <ng-container *cdkVirtualFor="let item of filtered_list; let i = index">
                            <div class="item" [class.hide]="hideActive && (item.i || i) === model" (touchrelease)="select(item.i >= 0 ? item.i || i : i)">
                                <div class="text">{{ item.name || item }}</div>
                                <div class="icon">
                                    <div class="done" *ngIf="model === (item.i || i) ? 1 : 0"></div>
                                </div>
                            </div>
                        </ng-container>
                    </cdk-virtual-scroll-viewport>
                </ng-container>
            </div>
            <div class="search" *ngIf="filter&&bottom" (touchrelease)="focus()">
                <div class="icon">
                    <div class="search-icon"></div>
                </div>
                <div class="input"><input #input [(ngModel)]="search" (ngModelChange)="filterItems()" placeholder="Filter"></div>
            </div>
            <div class="item active bottom" *ngIf="bottom" (touchrelease)="showList()">
                <div class="text" [class.placeholder]="model < 0 || !list_items || list_items.length <=model || !list_items[model]">
                    {{ model < 0 || !list_items || list_items.length <=model || !list_items[model] ? placeholder :
                        list_items[model].name || list_items[model] }} </div> <div class="icon">
                        <div class="up"></div>
                </div>
            </div>
        </div>
    </ng-template>
</div>
`,
    styles: [`@charset "UTF-8";.dropdown{position:relative;min-width:10em;display:inline-block;background-color:#fff;border-radius:4px;-webkit-box-shadow:0 1px 3px 0 rgba(0,0,0,.2),0 1px 1px 0 rgba(0,0,0,.14),0 2px 1px -1px rgba(0,0,0,.12);box-shadow:0 1px 3px 0 rgba(0,0,0,.2),0 1px 1px 0 rgba(0,0,0,.14),0 2px 1px -1px rgba(0,0,0,.12);-webkit-transition:background-color .3s,-webkit-box-shadow .6s;transition:box-shadow .6s,background-color .3s,-webkit-box-shadow .6s;overflow:hidden;cursor:pointer}.dropdown *{-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;user-select:none}.dropdown:hover{-webkit-box-shadow:0 2px 6px 0 rgba(0,0,0,.2),0 2px 2px 0 rgba(0,0,0,.14),0 4px 2px -2px rgba(0,0,0,.12);box-shadow:0 2px 6px 0 rgba(0,0,0,.2),0 2px 2px 0 rgba(0,0,0,.14),0 4px 2px -2px rgba(0,0,0,.12)}.dropdown.show,.dropdown.show:hover{-webkit-box-shadow:0 1px 3px 0 transparent,0 1px 1px 0 transparent,0 2px 1px -1px transparent;box-shadow:0 1px 3px 0 transparent,0 1px 1px 0 transparent,0 2px 1px -1px transparent}.dropdown.disable{-webkit-box-shadow:none;box-shadow:none;border:1px solid #ccc;opacity:.2;pointer-events:none}.reference{position:absolute;height:1em;pointer-events:none;opacity:0}.tooltip{position:absolute;top:0;left:0;right:0;height:1px;overflow:hidden;-webkit-box-sizing:content-box;box-sizing:content-box;opacity:0;display:block}.tooltip.bottom{top:auto;bottom:0}.item{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;height:2em;border:none}.item:hover{background-color:rgba(0,0,0,.1)}.item.active{text-align:center}.text{padding:.5em .75em;-webkit-box-flex:1;-ms-flex:1;flex:1;width:50%;overflow:hidden;white-space:nowrap;text-overflow:ellipsis}cdk-virtual-scroll-viewport{min-height:100%}.icon{width:1.5em;height:1.5em;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;-webkit-box-pack:center;-ms-flex-pack:center;justify-content:center;font-size:1.5em}.icon .down:before,.icon .up:before{content:'▾'}.icon .done:before{content:'✓'}.placeholder{overflow:hidden;padding:0 .75em;opacity:.54}.list{height:0;overflow:hidden}.list.show{height:auto;overflow:auto;max-height:12em}.search{display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;margin:.5em;border:1px solid #f2f2f2;padding:.5em;height:2em;border-radius:.2em;cursor:text}.search .icon{padding:0}.search-icon{height:1.5em;width:1.5em;background-origin:center;background-size:cover;background-repeat:no-repeat;background-image:url(data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij4KICAgIDxwYXRoIGQ9Ik0xNS41IDE0aC0uNzlsLS4yOC0uMjdDMTUuNDEgMTIuNTkgMTYgMTEuMTEgMTYgOS41IDE2IDUuOTEgMTMuMDkgMyA5LjUgM1MzIDUuOTEgMyA5LjUgNS45MSAxNiA5LjUgMTZjMS42MSAwIDMuMDktLjU5IDQuMjMtMS41N2wuMjcuMjh2Ljc5bDUgNC45OUwyMC40OSAxOWwtNC45OS01em0tNiAwQzcuMDEgMTQgNSAxMS45OSA1IDkuNVM3LjAxIDUgOS41IDUgMTQgNy4wMSAxNCA5LjUgMTEuOTkgMTQgOS41IDE0eiIvPgogICAgPHBhdGggZD0iTTAgMGgyNHYyNEgweiIgZmlsbD0ibm9uZSIvPgo8L3N2Zz4K)}.input{-webkit-box-flex:1;-ms-flex:1;flex:1}input{width:100%;border:none;outline:0;-webkit-box-shadow:none;box-shadow:none;border-radius:0;font-size:1em;-webkit-appearance:none;background:0 0}input:placeholder{color:rgba(0,0,0,.2)}.dropdown-list{border-radius:4px;overflow:hidden;-webkit-box-shadow:0 1px 3px 0 rgba(0,0,0,.2),0 1px 1px 0 rgba(0,0,0,.14),0 2px 1px -1px rgba(0,0,0,.12);box-shadow:0 1px 3px 0 rgba(0,0,0,.2),0 1px 1px 0 rgba(0,0,0,.14),0 2px 1px -1px rgba(0,0,0,.12)}.dropdown-list:hover{-webkit-box-shadow:0 1px 3px 0 rgba(0,0,0,.4),0 1px 1px 0 rgba(0,0,0,.28),0 2px 1px -1px rgba(0,0,0,.24);box-shadow:0 1px 3px 0 rgba(0,0,0,.4),0 1px 1px 0 rgba(0,0,0,.28),0 2px 1px -1px rgba(0,0,0,.24)}.dropdown-list .item.active{border-bottom:1px solid #f0f0f0}.dropdown-list .item.active.bottom{border:none;border-top:1px solid #f0f0f0}`],
    providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => DropdownComponent),
        multi: true
    }]
})
export class DropdownComponent extends BaseFormWidgetComponent<number> implements OnChanges, ControlValueAccessor {
    @Input() public list: string[] | { name: string; [fields: string]: any }[] = [];
    @Input() public filter = false;
    @Input() public placeholder = '';
    @Input() public hideActive = false;
    @Input() public html = '';
    @Output() public filterValue = new EventEmitter<string>();

    @ViewChild('ref') private reference: ElementRef;
    @ViewChild('body') private body: ElementRef;
    @ViewChild('active') private active: ElementRef;
    @ViewChild('input') private input: ElementRef;

    @ViewChild(CdkVirtualScrollViewport) private viewport: CdkVirtualScrollViewport;
    @ViewChild('viewport') private scroll_el: ElementRef;

    public show = false;
    public longest: string;
    public font_size = 20;
    public width = 200;
    public list_height = 0;
    public list_items: any[] = [];
    public filtered_list: any[] = [];
    public bottom = false;
    public search = '';

    public ngOnChanges(changes: SimpleChanges) {
        super.ngOnChanges(changes);
        if (changes.list) {
            this.processList();
        }
        this.timeout('resize', () => this.resize());
    }

    public select(index: number = 0) {
        this.model = index;
        this.modelChange.emit(this.model);
        this.change(this.model);
        this.show = false;
    }

    public focus() {
        if (this.input) {
            this.input.nativeElement.focus();
        }
    }

    public showList() {
        this.resize();
        this.show = true;
        this.updateScroll();
    }

    public updateScroll() {
        if (!this.viewport || !this.scroll_el) {
            return this.timeout('scroll', () => this.updateScroll(), 50);
        }
            // Add scroll viewport to element to allow for debugging and easier e2e testing
        this.viewport.elementRef.nativeElement.scroll_viewport = this.viewport;
        this.viewport.scrollToIndex(this.model);
    }

    public updateSize(tries: number = 0) {
        if (tries > 10) { return; }
        if (this.body && this.body.nativeElement) {
            this.width = this.body.nativeElement.offsetWidth;
        } else {
            setTimeout(() => this.updateSize(++tries), 200);
        }
    }

    public resize() {
        this.updateSize();
        if (this.reference && this.reference.nativeElement) {
            const box = this.reference.nativeElement.getBoundingClientRect();
            this.font_size = box.height;
        }
        if (this.active && this.active.nativeElement) {
            const box = this.active.nativeElement.getBoundingClientRect();
            const top = box.top + box.height / 2;
            const height = window.innerHeight || document.body.clientHeight;
            this.bottom = top > height / 2;
            this.processList();
        }
    }

    public filterItems() {
        if (this.search) {
            const s = this.search.toLowerCase();
            this.filtered_list = [];
            let index = 0;
            for (const i of this.list_items) {
                if (typeof i === 'string' && i.toLowerCase().indexOf(s) >= 0) {
                    this.filtered_list.push({
                        i: index,
                        name: i,
                    });
                } else if (i.name && i.name.toLowerCase().indexOf(s) >= 0) {
                    this.filtered_list.push({
                        i: index,
                        name: i.name,
                    });
                }
                index++;
            }
        } else {
            this.filtered_list = [ ...this.list_items ];
        }
        this.list_height = Math.min(8, this.filtered_list.length);
        this.filterValue.emit(this.search);
    }


    private processList() {
        if (this.list) {
            const list: any[] = [];
            this.longest = '1';
            for (const item of this.list) {
                if (typeof item === 'object') {
                    list.push(item || { name: '' });
                    if (item && item.name.length > this.longest.length) { this.longest = item.name; }
                } else {
                    list.push({ name: item });
                    if (item && item.length > this.longest.length) {  this.longest = item; }
                }
            }
            this.list_items = list;
            this.filterItems();
        }
    }

}
